import { Component, computed } from 'vue'
import { defineStore } from 'pinia'
import { getAccountLink, getOrdersLink } from '../useLinks'
import { useInvestmentProcessDataState } from '../investment-process/useInvestmentProcess'
import { getPendingInvestmentCookie } from '../investment-process/usePendingInvestmentProcess'
import { getCampaignData } from '../investment-process/useCampaign'
import { i18n } from '../../localization'
import InvestmentProcessSignteqSignature from '../../components/investmentProcess/signatures/InvestmentProcessSignteqSignature.vue'

export interface InvestmentStep {
    name: string
    label: string
    component: Component
}

export const useInvestmentProcessNavigation = defineStore('investment-process-navigation', {
    state: () => {
        return {
            pageKey: '',
            steps: [] as InvestmentStep[],
        }
    },
    getters: {
        currentStep: (state) => {
            return state.steps.find((step) => step.name === state.pageKey)
        },
        currentStepIndex: (state) => {
            const stepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
            if (stepIndex < 0) {
                return 0
            }
            return stepIndex
        },
    },
})

export const currentStep = computed((): InvestmentStep => {
    const state = useInvestmentProcessNavigation()
    return state.steps.find((step) => step.name === state.pageKey.value)
})

export function initializeInvestmentProcessNavigation(steps: InvestmentStep[]) {
    const investmentProcessNavigation = useInvestmentProcessNavigation()
    if (getCampaignData().asset_data.signature_signteq === true) {
        steps = addSignteqInvestmentStep(steps)
    }
    investmentProcessNavigation.steps = steps

    if (
        getPendingInvestmentCookie() &&
        getPendingInvestmentCookie().asset_uid === getCampaignData().asset_data.asset_uid
    ) {
        investmentProcessNavigation.pageKey = steps[getPendingInvestmentCookie().step].name
    } else {
        useInvestmentProcessDataState().setPendingInvestment()
        useInvestmentProcessDataState().saveBasket(1)
        investmentProcessNavigation.pageKey = steps[0].name
    }
}

function addSignteqInvestmentStep(steps: InvestmentStep[]): InvestmentStep[] {
    return [
        ...steps.slice(0, 3),
        {
            name: 'signteq_signature',
            label: i18n.global.t('investment_process.signature'),
            component: InvestmentProcessSignteqSignature,
        },
        ...steps.slice(3),
    ]
}

export function navigateToNextStep() {
    const state = useInvestmentProcessNavigation()
    const currentStepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
    if (currentStepIndex < state.steps.length - 1) {
        state.pageKey = state.steps[currentStepIndex + 1].name
    }

    if (currentStepIndex <= 1) {
        useInvestmentProcessDataState().setPendingInvestment()
        useInvestmentProcessDataState().saveBasket(currentStepIndex + 2)
    }
}

export function navigateToPreviousStep() {
    const state = useInvestmentProcessNavigation()
    const currentStepIndex = state.steps.findIndex((step) => step.name === state.pageKey)
    if (currentStepIndex >= 0) {
        state.pageKey = state.steps[currentStepIndex - 1].name
    }
    useInvestmentProcessDataState().setPendingInvestment()
    useInvestmentProcessDataState().saveBasket(currentStepIndex)
}

export function editPersonalData() {
    window.location = getAccountLink() + '?menu=Personal+Data'
}

export function editAddressData() {
    window.location = getAccountLink() + '?menu=Address+Data'
}

export function editCompanyData() {
    window.location = getAccountLink() + '?menu=Company+Data'
}

export function navigateToLandingPage() {
    window.location = '/'
}

export function navigateToOrders() {
    window.location = getOrdersLink()
}
